import { render, staticRenderFns } from "./PnrLink.vue?vue&type=template&id=6af67527&"
import script from "./PnrLink.vue?vue&type=script&lang=ts&"
export * from "./PnrLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports